<template>
    <!-- 附件 -->
    <div class="details">
        <header class="title">
            <span class="pole"></span>
            <span class="str">{{ info.title }}</span> 
        </header>
        <van-row type="flex" justify="space-between" class="content" v-for="(item,index) in info.files" :key="index" @click="preview(item)">
            <van-col span="6" class="caption">
                <van-file-icon :name="item.fileName.split('.')[1].substring(0,3)" size="60"></van-file-icon>
            </van-col>
            <van-col span="16" class="txt">
                <div>{{item.fileName}}</div>
                <!-- <div class="txt_size">25.38KB</div> -->
            </van-col>
            <!-- <van-col span="2" class="lr">
                <span class="spot_first"></span>
                <span class="spot_second"></span>
                <span class="spot_three"></span>
            </van-col> -->
        </van-row>

        <!-- 预览弹窗 -->
        <!-- <van-dialog v-model="show" :title="title" :show-confirm-button="false" :close-on-click-overlay="true">
            <iframe :src="fileSrc" frameborder="0" class="iframe" ></iframe>
        </van-dialog> -->
    </div>
</template>
<script>
import {Toast} from 'vant-green'
import * as bsOffice from "@/utils/bsOffice.js";
import {
    getFilesListData
} from "@/api/approve.js"
export default {
    props: {
        info: {
            type: Object,
            require: true
        }
    },
    data(){
        return {
            // show: false,
        }
    },
    methods: {
        //文件预览公共
        preview({guid,fileName}){
            if(fileName&&(fileName.endsWith('.zip')||fileName.endsWith('.ZIP')||fileName.endsWith('.7z')||fileName.endsWith('.7Z'))){
                return Toast.fail('此类型文件不支持预览')
            }
            bsOffice.read(guid,fileName)
        },
        //请求附件列表
        async getFilesDataList(){
            //获取上传的附件列表
            try{
                if(this.info.guids){
                    let res = await getFilesListData(this.info.guids);
                    if(res.data.data){
                        this.$emit("getFilesData",res.data.data);
                    }
                }
            } catch(e) {
                Toast({message: e,size: "small"});
            }
        }
    },
    watch: {
        'info.guids':{
            deep: true,
            immediate: true,
            handler(val){
                this.getFilesDataList();
            }
        }
    }
}
</script>
<style scoped lang="less">
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
            .lr{
                text-align: right;
                position: relative;
                span{
                    position: absolute;
                    right: 0;
                    top: 0;
                    display: inline-block;
                    border: 1px solid rgba(121, 121, 121, 1);
                }
                .spot_second{
                    top: 4px;
                }
                .spot_three{
                    top: 8px;
                }
            }
            .txt{
                margin-top: 15px;
                .txt_size{
                    color: @contentColor;
                }
            }
        }
        .content:last-child{
            border: unset;
        }
        .iframe{
            width: 100%;
            height: 500px;
            margin: 20px 0;
        }
        .no-file{
            line-height: 60px;
            text-align: center;
        }
    }
</style>